<template>
  <div id="details">
    <div class="c-equipmentArchive__filterTrigger">
		<button type="button" class="m-filterTrigger js-filter-btn" v-on:click="openFilterMobile">
      {{ mobile_button_title }}
			<div class="m-filterTrigger__icon">
        <span></span>
        <span></span>
        <span></span>
			</div>
		</button>
	</div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="c-equipmentArchive__colResultsSpacing"></div>
            <Header ref="headers" v-on:remove="remove" :lines="selection_lines" :body_parts="selection_body_parts" :types="selection_equipment_type" :recently_launched="selection_recently_launched" :count="count"></Header>
          </div>
        </div>
        <Filters 
          v-on:apply="apply" 
          :filter_mobile_is_active.sync="filter_mobile_is_active" 
          :text="text" 
          :body_parts="body_parts" 
          :lines="lines" 
          :equipment_types="equipment_types" 
          :recently_launched="recently_launched"
          :selection_body_parts="selection_body_parts" 
          :selection_lines="selection_lines" 
          :selection_equipment_type="selection_equipment_type" 
          :selection_recently_launched="selection_recently_launched"
          :current_page="current_page" 
          :limit="limit"
        ></Filters>
        <cards-result  v-on:change="changePage" v-on:increment="increment" v-on:decrement="decrement" :equipments="equipments" :count="count" :current_page="current_page" :limit="limit" ></cards-result>
      </div>
    </div>
  </div>
</template>
<script>

import Header from "./components/Header";
import CardsResult  from "./components/CardsResult";
import Filters from "./components/Filters";
import axios from "axios";

export default {
  name: 'equipement',
  components: {
    CardsResult,
    Header,
    Filters
  },
  data() {
    return {
      text: '',
      lang: window.Store.app.lang,
      lines: [],
      body_parts: [],
      equipment_types: [],
      recently_launched: [],
      selection_lines: [],
      selection_body_parts: [],
      selection_equipment_type: [],
      selection_recently_launched: [],
      equipments: [],
      current_page: 1,
      limit :12,
      count : 0,
      filter_mobile_is_active: false,
      // translation
      mobile_button_title: window.Store.translate_strings.filter ? window.Store.translate_strings.filter.mobile_button_title : '',

    }
  },
  mounted() {
    const r_line = axios
    .get('/wp-json/aco-rest/1.0.0/equipment/lines')
    .then(response => {
      let ids = response.data.map(line=>line.parent);
      ids = ids.filter(id=>id !== '0');
      const terms = response.data.filter(term => !ids.includes(term.term_id));
      this.lines = terms;
    });
    const r_parts = axios
    .get('/wp-json/aco-rest/1.0.0/equipment/bodyparts')
    .then(response => (this.body_parts = response.data));
    const r_types = axios
    .get('/wp-json/aco-rest/1.0.0/equipment/types')
    .then(response => (this.equipment_types = response.data));
    const r_recently_launched = axios
    .get('/wp-json/aco-rest/1.0.0/equipment/recentlylaunched')
    .then(response => (this.recently_launched = response.data));

    axios.all([r_line,r_parts,r_types, r_recently_launched]).then(()=>{
      // get url params terms
      const params = this.getQueryParams(window.location.search);
      const selection_lines = [];
      const selection_equipment_type = [];
      const selection_body_parts = [];
      const selection_recently_launched = [];
      if(typeof(params.term) !== 'undefined' && params.term.length >0) {
        selection_lines.push(...params.term);
        selection_equipment_type.push(...params.term);
        selection_recently_launched.push(...params.term);
      }
      if(typeof(params.post_id) !== 'undefined' && params.post_id.length > 0){
        selection_body_parts.push(...params.post_id);
      }
      if (Object.keys(params).length !== 0) {
        const selection_equipment = {
            lines: selection_lines,
            body_parts: selection_body_parts,
            equipment_type: selection_equipment_type,
            recently_launched: selection_recently_launched,
            current_page: this.current_page
        };
        window.sessionStorage.setItem('atlantis_equipment', JSON.stringify(selection_equipment));
      }
      this.apply(selection_lines, selection_body_parts, selection_equipment_type, selection_recently_launched, null, null, false);
    })
    this.initInput();
  },
  methods: {
    apply(selection_lines, selection_body_parts, selection_equipment_type, selection_recently_launched, text, page, scroll = true){
      if(typeof(page) !== 'undefined'){
        this.current_page = 1;
      }
      if (window.sessionStorage.getItem('atlantis_equipment')) {

        let json;
        try { json = JSON.parse(window.sessionStorage.getItem('atlantis_equipment')); } 
        catch (e) { console.log(e); }
        this.selection_lines = this.lines.filter(line => json.lines.includes(line.term_id) );
        this.selection_body_parts = this.body_parts.filter(part => json.body_parts.includes(part.post_id) );
        this.selection_equipment_type = this.equipment_types.filter(type => json.equipment_type.includes(type.term_id) );
        this.selection_recently_launched = this.recently_launched.filter(recently_launched => json.recently_launched.includes(recently_launched.term_id) );
        this.current_page = json.current_page || this.current_page;

      } else {

        if(typeof(selection_lines) !== 'undefined')
        this.selection_lines = this.lines.filter(line => selection_lines.includes(line.term_id) );
        if(typeof(selection_body_parts) !== 'undefined')
        this.selection_body_parts = this.body_parts.filter(part => selection_body_parts.includes(part.post_id) );
        if(typeof(selection_equipment_type) !== 'undefined')
        this.selection_equipment_type = this.equipment_types.filter(type => selection_equipment_type.includes(type.term_id) );
        if(typeof(selection_recently_launched) !== 'undefined')
        this.selection_recently_launched = this.recently_launched.filter(recently_launched => selection_recently_launched.includes(recently_launched.term_id) );
      }

      if(typeof(text) !== 'undefined')
        this.text = text;

      axios
      .get('/wp-json/aco-rest/1.0.0/equipment/search',{
        params: {
          lang : this.lang,
          text : this.text,
          lines : this.selection_lines.map(x => x.term_id),
          body : this.selection_body_parts.map(x => x.post_id),
          types: this.selection_equipment_type.map(x => x.term_id),
          launched: this.selection_recently_launched.map(x => x.term_id),
          limit : [(this.current_page-1)*this.limit, this.limit]
        }
      })
      .then(response => {
        this.equipments = response.data.data;
        this.count = parseInt(response.data.count);
        window.dispatchEvent(new Event('resize'));
        window.Store.scrollbar.element.update();
        if (scroll) {
          window.Store.scrollbar.scrollTo(document.querySelector('.c-equipmentArchive'));
        }
      });
    },
    remove: function(selection_line, selection_body_part, selection_type, selection_recently_launched){
        this.selection_body_parts = selection_body_part ? this.selection_body_parts.filter((value)=> value.post_id !== selection_body_part.post_id) : this.selection_body_parts;
        let body_parts_arr  = [];
        this.selection_body_parts.forEach(item => {
            body_parts_arr.push(item.post_id);
        });
        this.selection_lines = selection_line ? this.selection_lines.filter((value)=> value.term_id !== selection_line.term_id) : this.selection_lines;
        let lines_arr  = [];
        this.selection_lines.forEach(item => {
            lines_arr.push(item.term_id);
        })
        this.selection_equipment_type = selection_type ? this.selection_equipment_type.filter((value)=> value.term_id !== selection_type.term_id) : this.selection_equipment_type;
        let equipment_type_arr  = [];
        this.selection_equipment_type.forEach(item => {
            equipment_type_arr.push(item.term_id);
        })
        this.selection_recently_launched = selection_recently_launched ? this.selection_recently_launched.filter((value)=> value.term_id !== selection_recently_launched.term_id) : this.selection_recently_launched;
        let recently_launched_arr  = [];
        this.selection_recently_launched.forEach(item => {
            recently_launched_arr.push(item.term_id);
        })
        this.current_page = 1;
        const selection_equipment = {
            body_parts: body_parts_arr,
            lines: lines_arr,
            equipment_type: equipment_type_arr,
            recently_launched: recently_launched_arr
        };
        window.sessionStorage.setItem('atlantis_equipment', JSON.stringify(selection_equipment));
        this.apply();
    },
    increment: function(){
      this.current_page++;

      const selection_equipment = {
        lines: this.selection_lines.map(el => el.term_id),
        body_parts: this.selection_body_parts.map(el => el.post_id),
        equipment_type: this.selection_equipment_type.map(el => el.term_id),
        recently_launched: this.selection_recently_launched.map(el => el.term_id),
        current_page: this.current_page
      };
      window.sessionStorage.setItem('atlantis_equipment', JSON.stringify(selection_equipment));

      this.apply();
    },
    decrement: function(){
      this.current_page--;

      const selection_equipment = {
        lines: this.selection_lines.map(el => el.term_id),
        body_parts: this.selection_body_parts.map(el => el.post_id),
        equipment_type: this.selection_equipment_type.map(el => el.term_id),
        recently_launched: this.selection_recently_launched.map(el => el.term_id),
        current_page: this.current_page
      };
      window.sessionStorage.setItem('atlantis_equipment', JSON.stringify(selection_equipment));

      this.apply();
    },
    changePage: function(page){
      this.current_page = page;
       const selection_equipment = {
        lines: this.selection_lines.map(el => el.term_id),
        body_parts: this.selection_body_parts.map(el => el.post_id),
        equipment_type: this.selection_equipment_type.map(el => el.term_id),
        recently_launched: this.selection_recently_launched.map(el => el.term_id),
        current_page: this.current_page
      };
      window.sessionStorage.setItem('atlantis_equipment', JSON.stringify(selection_equipment));
      this.apply();
    },
    openFilterMobile: function() {
      this.filter_mobile_is_active = !this.filter_mobile_is_active;
      window.Store.app.theBody.classList.add('filter-active');
    },
    getQueryParams : (query) => {
      let params = {};
      new URLSearchParams(query).forEach((value, key) => {
        let decodedKey = decodeURIComponent(key);
        let decodedValue = decodeURIComponent(value);
        // This key is part of an array
        if (decodedKey.endsWith("[]")) {
          decodedKey = decodedKey.replace("[]", "");
          params[decodedKey] || (params[decodedKey] = []);
          params[decodedKey].push(decodedValue);
          // Just a regular parameter
        } else {
          params[decodedKey] = decodedValue;
        }
      });

      return params;
    },
    initInput: function() {
      window.Store.components.inputs.render();
    }
  }
}
</script>
